import React from "react";
import "./customButton.css";
const CustomButton = ({
  type = "primary",
  btnText,
  onClick,
  flex = false,
  style = {},
  disabled = false,
  // btnType="button",
}) => {
  return (
    <button
      onClick={onClick}
      className="btn"
      // type={btnType}
      style={{
        backgroundColor:
          type === "danger"
            ? "#D04244"
            : type === "disable"
            ?"#aab1c1"
            : type === "secondary"
            ? "#FAFDFF"
            : "#314064",

        fontWeight: "500",
        
        color: type === "secondary" ? "#314064" : "#fff",

        //  alignSelf:"flex-start",
        outline: "none",
        borderStyle: "solid",
        textTransform: "uppercase",
        borderColor: type === "secondary" ? "#314064" : "transparent",
        cursor: "pointer",
        ...style,
      }}
      disabled={disabled}
    >
      {btnText}
    </button>
  );
};

export default CustomButton;
